module.exports = __webpack_public_path__ + "assets/img/box1.7869909f.png";